/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

//TODO: Make the contansts separate for each module

export const APIRoutes = {
    customer: {
        transactions: {
            lines: {
                retrieve: {
                    api: 'CustomerEnquiry/Customer/:CustomerId/Transactions',
                    method: 'POST'
                },
            }
        },
        invoices: {
            lines: {
                retrieve: {
                    api: 'CustomerEnquiry/Customer/:CustomerId/Invoices',
                    method: 'POST'
                }
            }
        }
    },
    inventory: {
        stockingquantities: {
            lines: {
                retrieve: {
                    api: 'InventoryEnquiry/Product/:ProductId/StockingQuantities',
                    method: 'GET'
                },
            }
        }
    },
};
